import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css';
import Home from './pages/Home';
import SingleChannel from './pages/SingleChannel';
import VideoPlayer from './pages/VideoPlayer';
import Search from './pages/Search';

import { LoginModal } from './components/LoginModal';
import Favorites from './pages/Favorites';

import { AlertProvider } from './AlertContext';
import Profile from './pages/Profile';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AlertProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/video" element={<VideoPlayer />} />
        <Route path="/single" element={<SingleChannel />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/search" element={<Search />} />
        <Route path="/profile" element={<Profile />} />
        
      </Routes>
      <LoginModal />
    </AlertProvider>
  </BrowserRouter>
);

